import React, { useEffect, useState } from "react";
import { Eye } from "lucide-react";
import { api } from "@/lib/api";
import { getVisitorId } from "@/lib/ads";
import { useI18n } from "@/i18n";

export function ReadersCount({ articleId }) {
  const { t, lang } = useI18n();
  const [count, setCount] = useState(null);
  useEffect(() => {
    api.post(`/articles/${articleId}/read`, { vid: getVisitorId() })
      .then(({ data }) => setCount(data.readers))
      .catch(() => {});
  }, [articleId]);
  if (count === null) return null;
  return (
    <p data-testid="article-readers-count" className="mt-6 inline-flex items-center gap-2 text-sm text-slate-600">
      <Eye size={16} className="text-violet-600" />
      {t("common.readers")}: <span data-testid="article-readers-number" className="font-mono font-semibold text-slate-900">{count.toLocaleString(lang === "ar" ? "ar-EG" : "en-US")}</span>
    </p>
  );
}
